import React from 'react'
import styles from './styles.module.scss'
import { first, second, third, logo } from '../../../assets/img/dashCategoris'
import { NavLink } from 'react-router-dom'
import { arrowRight } from '../../../assets/svg/dashboard/main'
import { CIUP_STRUCTURE } from '../../../utils/const'


const CATEGORIES = [
  { name: 'Среднее профессиональное образование', mode: 'spo', img: first },
  { name: 'Высшее образование', mode: 'vo',  img: second },
  // { name: 'ДО', mode: 'do', img: third },
]

const Main = () => {
  
  
  const renderCategory = ({ name, mode, img }) => {
    const criteria = CIUP_STRUCTURE[mode][0].value
    const link = `/dashboard_new/ciup/${mode}/${criteria}`
    return (
      <li className={styles.card} key={name}>
        <NavLink to={link}>
          <div>
            <p>{name}</p>
            <div>{arrowRight}</div>
          </div>
        <img src={img} alt={name} />
        </NavLink>
      </li>
    )
  }
  
  
  return (
    <div className={styles.mainWrap}>
      <ul>{CATEGORIES.map(renderCategory)}</ul>
    </div>
  )
}

export default Main